import { IDsDoiTuongDuThiUpdateDuyetRequest } from "../../model/request/tct/IDsDoiTuongDuThiUpdateDuyetRequest"
import { apiClient } from "../apiClient"

const DANH_DANH_DOI_TUONG_DU_THI_API = "danh-sach-doi-tuong-du-thi"
export const dsDoiTuongDuThiApi = {
   SelectByDotThi: (id_dot_thi: number) => apiClient.get(`${DANH_DANH_DOI_TUONG_DU_THI_API}/dot-thi/${id_dot_thi}`),
   UpdateDuyet: (request: IDsDoiTuongDuThiUpdateDuyetRequest) => apiClient.put(`${DANH_DANH_DOI_TUONG_DU_THI_API}/duyets`, request),
}